(function () {
  "use strict";

  var root = document.querySelector("[data-kimi-product]");
  if (!root) return;

  var gallery = root.querySelector("[data-kimi-gallery]");
  var galleryFrame = root.querySelector(".kpdp__frame");
  var mainImage = root.querySelector("[data-kimi-main-image]");
  var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-kimi-thumb]"));
  var galleryCount = root.querySelector("[data-kimi-gallery-count]");
  var activeImage = 0;
  var touchStartX = 0;
  var touchStartY = 0;
  var dragPointerId = null;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragDeltaX = 0;
  var imageTransitionTimer = null;

  thumbs.forEach(function (item) {
    var imageUrl = item.getAttribute("data-image");
    if (!imageUrl) return;
    var preload = new Image();
    preload.src = imageUrl;
  });

  function updateMainImage(thumb) {
    if (!mainImage || !thumb) return;
    var nextSource = thumb.getAttribute("data-image");
    var nextAlt = thumb.getAttribute("data-alt") || "";
    if (!nextSource) return;

    if (!galleryFrame || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      mainImage.src = nextSource;
      mainImage.alt = nextAlt;
      return;
    }

    Array.prototype.slice.call(galleryFrame.querySelectorAll(".kpdp__transition-image")).forEach(function (image) {
      image.remove();
    });
    window.clearTimeout(imageTransitionTimer);

    var outgoingImage = mainImage.cloneNode(false);
    outgoingImage.removeAttribute("data-kimi-main-image");
    outgoingImage.removeAttribute("id");
    outgoingImage.classList.remove("is-entering");
    outgoingImage.classList.add("kpdp__transition-image");
    outgoingImage.style.transform = "";
    galleryFrame.appendChild(outgoingImage);

    mainImage.classList.remove("is-entering");
    mainImage.src = nextSource;
    mainImage.alt = nextAlt;
    void mainImage.offsetWidth;
    mainImage.classList.add("is-entering");

    imageTransitionTimer = window.setTimeout(function () {
      outgoingImage.remove();
      mainImage.classList.remove("is-entering");
    }, 280);
  }

  function selectImage(index, scrollThumb) {
    if (!thumbs.length) return;
    activeImage = (index + thumbs.length) % thumbs.length;
    thumbs.forEach(function (item, itemIndex) {
      var active = itemIndex === activeImage;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-pressed", active ? "true" : "false");
    });
    var thumb = thumbs[activeImage];
    updateMainImage(thumb);
    if (galleryCount) galleryCount.textContent = String(activeImage + 1) + " / " + String(thumbs.length);
    if (scrollThumb && thumb && thumb.scrollIntoView) thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener("click", function () { selectImage(index, false); });
  });

  var previous = root.querySelector("[data-kimi-prev]");
  var next = root.querySelector("[data-kimi-next]");
  if (previous) previous.addEventListener("click", function () { selectImage(activeImage - 1, true); });
  if (next) next.addEventListener("click", function () { selectImage(activeImage + 1, true); });

  if (gallery) {
    gallery.addEventListener("touchstart", function (event) {
      if (!event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    gallery.addEventListener("touchend", function (event) {
      if (!event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      selectImage(activeImage + (deltaX < 0 ? 1 : -1), true);
    }, { passive: true });
  }

  if (galleryFrame) {
    if (mainImage) mainImage.setAttribute("draggable", "false");

    function resetDesktopDrag() {
      dragPointerId = null;
      dragDeltaX = 0;
      galleryFrame.classList.remove("is-dragging");
      if (mainImage) mainImage.style.transform = "";
    }

    function finishDesktopDrag(event, selectNextImage) {
      if (event.pointerId !== dragPointerId) return;
      var deltaX = dragDeltaX;
      var deltaY = event.clientY - dragStartY;
      if (galleryFrame.hasPointerCapture && galleryFrame.hasPointerCapture(event.pointerId)) {
        galleryFrame.releasePointerCapture(event.pointerId);
      }
      resetDesktopDrag();
      if (selectNextImage && Math.abs(deltaX) >= 52 && Math.abs(deltaX) > Math.abs(deltaY)) {
        selectImage(activeImage + (deltaX < 0 ? 1 : -1), true);
      }
    }

    galleryFrame.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      if (event.target.closest && event.target.closest("button")) return;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragDeltaX = 0;
      galleryFrame.classList.add("is-dragging");
      galleryFrame.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    galleryFrame.addEventListener("pointermove", function (event) {
      if (event.pointerId !== dragPointerId) return;
      dragDeltaX = event.clientX - dragStartX;
      event.preventDefault();
    });

    galleryFrame.addEventListener("pointerup", function (event) {
      finishDesktopDrag(event, true);
    });
    galleryFrame.addEventListener("pointercancel", function (event) {
      finishDesktopDrag(event, false);
    });
    galleryFrame.addEventListener("lostpointercapture", resetDesktopDrag);
    galleryFrame.addEventListener("dragstart", function (event) { event.preventDefault(); });
  }

  var compareRail = document.querySelector("[data-kimi-compare-scroll]");
  var comparePrevious = document.querySelector("[data-kimi-compare-prev]");
  var compareNext = document.querySelector("[data-kimi-compare-next]");

  function updateCompareControls() {
    if (!compareRail) return;
    var maxScroll = Math.max(0, compareRail.scrollWidth - compareRail.clientWidth);
    if (comparePrevious) comparePrevious.disabled = compareRail.scrollLeft <= 3;
    if (compareNext) compareNext.disabled = compareRail.scrollLeft >= maxScroll - 3;
  }

  function scrollComparison(direction) {
    if (!compareRail) return;
    compareRail.scrollBy({ left: direction * Math.max(220, compareRail.clientWidth * .72), behavior: "smooth" });
  }

  if (comparePrevious) comparePrevious.addEventListener("click", function () { scrollComparison(-1); });
  if (compareNext) compareNext.addEventListener("click", function () { scrollComparison(1); });
  if (compareRail) {
    compareRail.addEventListener("scroll", updateCompareControls, { passive: true });
    window.addEventListener("resize", updateCompareControls);
    updateCompareControls();
  }

  var variantInputs = Array.prototype.slice.call(root.querySelectorAll("[data-kimi-variant]"));
  var price = root.querySelector("[data-kimi-price]");
  var stickyPrice = document.querySelector("[data-kimi-sticky-price]");
  var stickyChoice = document.querySelector("[data-kimi-sticky-choice]");
  var subscriptionToggle = root.querySelector("[data-kimi-subscription-toggle]");
  var subscriptionState = root.querySelector("[data-kimi-subscription-state]");
  var subscriptionSaving = root.querySelector("[data-kimi-subscription-saving]");
  var purchaseNote = root.querySelector("[data-kimi-purchase-note]");
  var sellingPlanInput = root.querySelector("[data-kimi-selling-plan]");

  function subscriptionIsOn() {
    return Boolean(subscriptionToggle && subscriptionToggle.checked);
  }

  function priceFor(input, unitPrice) {
    var prefix = subscriptionIsOn() ? "data-subscription-" : "data-one-time-";
    return input.getAttribute(prefix + (unitPrice ? "unit-price" : "price")) || "";
  }

  function purchaseCopyFor(input, name) {
    var prefix = subscriptionIsOn() ? "data-subscription-" : "data-one-time-";
    return input.getAttribute(prefix + name) || "";
  }

  function updateSubscriptionBenefits() {
    if (!subscriptionToggle) return;
    if (subscriptionState) subscriptionState.textContent = subscriptionState.getAttribute(subscriptionIsOn() ? "data-on-label" : "data-off-label");
    if (purchaseNote) purchaseNote.textContent = purchaseNote.getAttribute(subscriptionIsOn() ? "data-subscription-label" : "data-one-time-label");
    root.querySelectorAll("[data-kimi-subscription-bonus]").forEach(function (bonus) {
      bonus.hidden = !subscriptionIsOn();
    });
  }

  function updateVisibleCardPrices() {
    variantInputs.forEach(function (input) {
      var card = input.closest(".kpdp__variant");
      if (!card) return;
      var total = card.querySelector("[data-kimi-card-total]");
      var unit = card.querySelector("[data-kimi-card-unit]");
      var unitLabel = card.querySelector("[data-kimi-card-unit-label]");
      var gift = card.querySelector("[data-kimi-card-gift]");
      var renewal = card.querySelector("[data-kimi-card-renewal]");
      var pack = card.querySelector("[data-kimi-card-pack]");
      var supply = card.querySelector("[data-kimi-card-supply]");
      var promo = card.querySelector("[data-kimi-card-promo]");
      if (pack && purchaseCopyFor(input, "pack-label")) pack.textContent = purchaseCopyFor(input, "pack-label");
      if (supply && purchaseCopyFor(input, "supply")) supply.textContent = purchaseCopyFor(input, "supply");
      if (promo) {
        promo.textContent = purchaseCopyFor(input, "promo");
        promo.hidden = !promo.textContent;
      }
      if (total) total.textContent = priceFor(input, false);
      if (unit) unit.textContent = priceFor(input, true);
      if (unitLabel) unitLabel.textContent = purchaseCopyFor(input, "unit-label");
      if (gift) gift.textContent = purchaseCopyFor(input, "gift");
      if (renewal) {
        renewal.textContent = purchaseCopyFor(input, "renewal");
        renewal.hidden = !renewal.textContent;
      }
    });
    updateSubscriptionBenefits();
  }

  function selectVariant(input) {
    variantInputs.forEach(function (item) {
      var card = item.closest(".kpdp__variant");
      if (card) card.classList.toggle("is-active", item.checked);
    });
    var nextPrice = priceFor(input, false) || input.getAttribute("data-price") || "";
    if (subscriptionSaving) {
      var oneTimeCents = Number(input.getAttribute("data-one-time-price-cents"));
      var subscriptionCents = Number(input.getAttribute("data-subscription-price-cents"));
      var savingPercent = oneTimeCents > 0 ? Math.round((oneTimeCents - subscriptionCents) * 100 / oneTimeCents) : 0;
      subscriptionSaving.textContent = subscriptionSaving.getAttribute("data-label").replace("__percentage__", savingPercent);
      subscriptionSaving.hidden = savingPercent <= 0;
    }
    var nextShipping = input.getAttribute("data-shipping") || "";
    var cardTitle = input.closest(".kpdp__variant").querySelector("b");
    var offerName = input.getAttribute("data-offer-name") || (cardTitle ? cardTitle.textContent : "Gut Freak");
    if (price) price.textContent = nextPrice;
    if (stickyPrice) stickyPrice.textContent = nextPrice;
    if (stickyChoice) {
      var choiceParts = [offerName, subscriptionIsOn() ? "Subscription" : "One-time"];
      if (nextShipping) choiceParts.push(nextShipping);
      stickyChoice.textContent = choiceParts.join(" · ");
    }
    if (sellingPlanInput) sellingPlanInput.value = subscriptionIsOn() ? (input.getAttribute("data-selling-plan") || "") : "";
  }

  variantInputs.forEach(function (input) {
    input.addEventListener("change", function () { selectVariant(input); });
  });

  if (subscriptionToggle) {
    subscriptionToggle.addEventListener("change", function () {
      updateVisibleCardPrices();
      var selected = variantInputs.find(function (input) { return input.checked; });
      if (selected) selectVariant(selected);
    });
  }

  updateVisibleCardPrices();
  var requestedPack = new URLSearchParams(window.location.search).get("pack");
  var requestedInput = requestedPack && variantInputs.find(function (input) {
    return input.getAttribute("data-pack") === requestedPack;
  });
  if (requestedInput) {
    variantInputs.forEach(function (input) { input.checked = input === requestedInput; });
  }
  var initiallySelected = requestedInput || variantInputs.find(function (input) { return input.checked; });
  if (initiallySelected) selectVariant(initiallySelected);

  var productForm = root.querySelector("[data-kimi-product-form]");
  var primaryAdd = root.querySelector("[data-kimi-primary-add]");
  var primaryCta = root.querySelector("[data-kimi-primary-cta]") || primaryAdd;
  var sticky = document.querySelector("[data-kimi-sticky]");
  var stickySubmit = document.querySelector("[data-kimi-sticky-submit]");
  if (stickySubmit && productForm && primaryAdd) {
    stickySubmit.addEventListener("click", function () { productForm.requestSubmit(primaryAdd); });
  }

  function setStickyVisibility(show) {
    if (!sticky) return;
    sticky.classList.toggle("is-visible", show);
    sticky.setAttribute("aria-hidden", show ? "false" : "true");
  }

  if (sticky && primaryCta && "IntersectionObserver" in window) {
    var addObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      setStickyVisibility(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
    }, { threshold: 0 });
    addObserver.observe(primaryCta);
  } else if (sticky && primaryCta) {
    var stickyTicking = false;
    var updateSticky = function () {
      setStickyVisibility(primaryCta.getBoundingClientRect().bottom <= 0);
      stickyTicking = false;
    };
    var requestStickyUpdate = function () {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(updateSticky);
    };
    window.addEventListener("scroll", requestStickyUpdate, { passive: true });
    window.addEventListener("resize", requestStickyUpdate);
    updateSticky();
  } else {
    setStickyVisibility(false);
  }
})();
